<template lang="html">
  <footer>
    <section>
      <div class="wrapper main-foot">
        <div class="yellow logo pt-4">
          <GradientKeys />
        </div>

        <div class="subscribe">
          <h3>Stay tuned for the next episode</h3>
          <form
            v-if="showSuccessfulSubmit === false"
            @submit.prevent="subscribe">
            <input
              v-model="email"
              class="gray"
              type="email"
              placeholder="you@probablygmail.com"
              disabled>
            <button
              v-if="loading === false"
              type="submit" disabled>Submit</button>
            <Spinner v-else />
          </form>
          <div
            v-else
            class="yellow">Thanks! We'll let you know when the next episode airs.</div>

          <div
            v-if="showErrorMessage === true"
            class="yellow mt-4">
            Something went wrong on our end, and we are super duper sorry. Please try again, you magnificent sea urchin.
          </div>
        </div>

        <div class="links">
          <h3>Super Important Information</h3>
          <ul>
            <li>
              <router-link to="/faq">FAQ</router-link>
            </li>
            <li>
              <router-link to="/contact">Contact</router-link>
            </li>
            <li>
              <a
                href="https://www.youtube.com/watch?v=oHg5SJYRHA0"
                target="_blank"
                rel="noreferrer noopener">Complaints
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section>
      <div class="wrapper sub-foot">
        <div class="social-links">
          <a href="https://twitter.com/iamcatholicaf"><Twitter /></a>
          <a href="https://instagram.com/iamcatholicaf"><Insta /></a>
        </div>

        <div class="copyright">
          <p
            v-once
            class="blue">&copy; Copyright Catholic AF {{ year }}</p>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import GradientKeys from '@/components/svgs/GradientKeys'
import Twitter from '@/components/svgs/Twitter'
import Insta from '@/components/svgs/Insta'
import Spinner from '@/components/Spinner'

export default {
  components: {
    GradientKeys,
    Twitter,
    Insta,
    Spinner
  },
  data() {
    return {
      loading: false,
      email: '',
      showSuccessfulSubmit: false,
      showErrorMessage: false
    }
  },
  created() {
    this.year = new Date().getFullYear()
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/partials/colors.scss';

footer {
  background-color: $black;
  color: $blue;
  display: grid;
  grid-template-rows: 1fr auto;
  min-height: 300px;
  a {
    color: $blue;
    text-decoration: none;
  }
  a:hover {
    color: $yellow;
  }
  a:hover svg {
    fill: $yellow;
  }
  section {
    width: 100%;
    &:last-child {
      border-top: 2px solid $darkBlue;
    }
  }
  .wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
    max-width: 70rem;
    padding: 1rem;
    width: 100%;
  }
  .main-foot {
    display: grid;
    grid-row-gap: 3rem;
    grid-template-columns: 1fr;
    grid-template-rows: 75px 1fr;
    padding-bottom: 3rem;
    @media screen and (min-width: 700px) {
      grid-row-gap: 1rem;
      grid-template-columns: 1fr 1fr;
      padding-bottom: 1rem;
    }
    @media screen and (min-width: 992px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
  .logo {
    grid-column: 1 / -1;
    flex: 0 0 100%;
    height: 57px;
    justify-self: center;
    width: 63px;
  }
  .links {
    text-align: center;
    @media screen and (min-width: 700px) {
      grid-column-start: -2;
      text-align: right;
    }
    ul {
      display: flex;
      justify-content: center;
      list-style: none;
      margin: 0;
      padding: 8px 0;
      @media screen and (min-width: 700px) {
        justify-content: flex-end;
      }
    }
    li {
      margin-left: 1.5rem;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .subscribe {
    margin: 0 auto;
    text-align: center;
    width: 100%;
    @media screen and (min-width: 500px) {
      width: 80%;
    }
    @media screen and (min-width: 700px) {
      text-align: left;
      width: 100%;
    }
  }
  h3 {
    color: #fff;
    font-weight: 400;
    text-transform: uppercase;
  }
  form {
    border: 2px solid $darkBlue;
    display: flex;
    align-items: center;
    &:focus-within {
      border: 2px solid $blue;
      outline: none;
    }
  }
  input {
    background-color: transparent;
    border: none;
    padding: 8px 12px;
    width: 100%;
    &:focus {
      outline: none;
    }
  }
  button {
    background-color: transparent;
    border: none;
    color: $blue;
    padding: 10px;
    text-transform: uppercase;
    &:hover,
    &:focus {
      color: $yellow;
    }
  }

  button:disabled, input:disabled {
    color: $middleGray;
    cursor: not-allowed;
  }

  .sub-foot {
    align-items: center;
    p {
      margin: 0;
    }
    a {
      margin-right: 24px;
    }
  }
}
</style>
